import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import { saveAs } from "file-saver";
import * as moment from 'moment';

@Component({
  selector: "app-zns-failed-manager",
  templateUrl: "./zns-failed-manager.component.html",
  styleUrls: ["./zns-failed-manager.component.scss"],
})
export class ZnsFailedManagerComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private eventService: EventService,
    private translateService: TranslateService
  ) {}

  tableName = "subrenew-zalo-noti/failed";
  listData = [];
  pageSize = 10;
  pageIndex = 1;
  totalCount = 0;
  params = "";
  searching;

  listDayRange = [
    { value: 3, label: "3 ngày" },
    { value: 7, label: "7 ngày" },
    { value: 14, label: "14 ngày" },
  ];

  filter = {
    acc_number: "",
    phone: "",
    receiver_phone: "",
    dayRange: "",
  };

  ngOnInit() {
    this.submitFilter();
  }

  submitFilter() {
    this.params = "";
    Object.keys(this.filter).forEach((key) => {
      if (this.filter[key]) {
        this.params += `&${key}=${this.filter[key]}`;
      }
    });
    this.pageIndex = 1;
    this.searching = true;
    this.fetchData();
  }

  clearFilter() {
    this.filter.acc_number = "";
    this.filter.phone = "";
    this.filter.receiver_phone = "";
    this.filter.dayRange = "";
    this.params = "";
    this.searching = false;
    this.pageIndex = 1;
    this.fetchData();
  }

  fetchData() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName + `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res.metadata["results"] ? res.metadata["results"] : [];
          this.totalCount = res.metadata.pagination.totalCount
            ? res.metadata.pagination.totalCount
            : 0;
          this.eventService.setLoading(false);
        },
        error: () => {
          this.eventService.setLoading(false);
        },
      });
  }

  exportExcel() {
    this.eventService.setLoading(true);
    const headers = new HttpHeaders({
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = "subrenew-zalo-noti/failed/export?" + this.params;

    this.http
      .get(url, { headers, responseType: "blob", observe: "response" })
      .subscribe({
        next: (res) => {
          this.eventService.setLoading(false);
          const disposition = res.headers.get("content-disposition") || "";
          const match = disposition.match(/filename="?([^"]+)"?/);
          const fileName = match ? match[1] : `ZNS-nhac-gia-han-gui-loi_CSKH_${moment().format("YYYYMMDDHHmmss")}.xlsx`;
          saveAs(res.body, fileName);
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Xuất file lỗi")
          );
          this.eventService.setLoading(false);
        },
      });
  }
}
